import React, { createContext, useContext, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface TourContextType {
    startTour: (tourId: string, force?: boolean) => void;
    stopTour: () => void;
    isRunning: boolean;
    currentTour: string | null;
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export const useTour = () => {
    const { t } = useTranslation();
    const context = useContext(TourContext);
    if (!context) {
        throw new Error(t('tour_provider.use_tour_error') as string);
    }
    return context;
};

interface TourProviderProps {
    children: React.ReactNode;
}

export const TourProvider: React.FC<TourProviderProps> = ({ children }) => {
    const [isRunning, setIsRunning] = useState(false);
    const [currentTour, setCurrentTour] = useState<string | null>(null);

    const startTour = useCallback((tourId: string, force: boolean = false) => {
        const isCompleted = localStorage.getItem(`tour_completed_${tourId}`);
        if (isCompleted && !force) {
            return;
        }
        setCurrentTour(tourId);
        setIsRunning(true);
    }, []);

    const stopTour = useCallback(() => {
        setIsRunning(false);
        setCurrentTour(null);
    }, []);

    return <TourContext.Provider value={{ startTour, stopTour, isRunning, currentTour }}>{children}</TourContext.Provider>;
};
